export default "__VITE_ASSET__BDX57kVY__"